import React from 'react';
import { AdvancedMarker, APIProvider, Map, Pin } from '@vis.gl/react-google-maps';
import { getConfig } from '../../appConfig';
import { isWebConfig } from '../../lib/utils';

const mapStyles = {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  map: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
};

export class MapWrapper extends React.Component {
  constructor(props) {
    super(props);

    if (!props.hasOwnProperty('google')) {
      throw new Error('You must include a `google` prop');
    }

    this.listeners = {};
    this.state = {
      mapConfig: {
        defaultCenter: { lat: 37.774929, lng: -122.419416 },
        defaultZoom: 10,
        reuseMaps: true,
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedLocation !== this.props.selectedLocation) {
      this.changeLocation(this.props.selectedLocation, this.props.showMap);
    }
    else if (prevProps.showMap !== this.props.showMap) {
      this.changeLocation(this.props.selectedLocation, this.props.showMap);
    }
  }

  handleCameraChange(ev) {
    const { mapConfig } = this.state;
    this.setState({ mapConfig: { ...mapConfig, center: ev.detail.center, zoom: ev.detail.zoom } });
  }

  changeLocation(location, showMap) {
    let { zoom, latitudeOffset, longitudeOffset } = this.props;
    if(isWebConfig()){
      latitudeOffset = 0.002

    }else{
      if (!showMap) {
        latitudeOffset = 0.004
      }
    }
  
    const { mapConfig } = this.state;
    this.setState({
      mapConfig: {
        ...mapConfig,
        center: { lat: parseFloat(location.latitude) - (latitudeOffset || 0), lng: parseFloat(location.longitude) - (longitudeOffset || 0) },
        zoom: zoom || 10
      }
    });
  }

  componentDidMount() {
    const {
      zoom,
      clickableIcons,
      disableDefaultUI,
      zoomControl,
      zoomControlOptions,
      mapTypeControl,
      mapTypeControlOptions,
      scaleControl,
      streetViewControl,
      streetViewControlOptions,
      panControl,
      rotateControl,
      fullscreenControl,
      scrollwheel,
      draggable,
      draggableCursor,
      keyboardShortcuts,
      disableDoubleClickZoom,
      noClear,
      styles,
      gestureHandling,
      locations,
      selectedLocation,
      latitudeOffset,
      longitudeOffset
    } = this.props;
    let position = { lat: 0, lng: 0 };
    if (locations && locations.length > 0) {
      const location = selectedLocation || locations[0];
      position = { lat: parseFloat(location.latitude) - (latitudeOffset || 0), lng: parseFloat(location.longitude) - (longitudeOffset || 0) };
    }
    const mapConfig = {
      defaultCenter: position,
      center: position,
      defaultZoom: zoom || 10,
      clickableIcons: !!clickableIcons,
      disableDefaultUI: disableDefaultUI,
      zoomControl: zoomControl,
      zoomControlOptions: zoomControlOptions,
      mapTypeControl: mapTypeControl,
      mapTypeControlOptions: mapTypeControlOptions,
      scaleControl: scaleControl,
      streetViewControl: streetViewControl,
      streetViewControlOptions: streetViewControlOptions,
      panControl: panControl,
      rotateControl: rotateControl,
      fullscreenControl: fullscreenControl,
      scrollwheel: scrollwheel,
      draggable: draggable,
      draggableCursor: draggableCursor,
      keyboardShortcuts: keyboardShortcuts,
      disableDoubleClickZoom: disableDoubleClickZoom,
      noClear: noClear,
      styles: styles,
      gestureHandling: gestureHandling,
      reuseMaps: true,
    };
    this.setState({
      mapConfig: mapConfig
    }, () => {
      this.changeLocation(this.props.selectedLocation, false);

    });
  }
  calculateOffsetCenter = (lat, lng, zoom) => {
    const latOffset = 0.002;
    return { lat: lat - latOffset, lng };
  };
  render() {
    const {
      containerStyle,
      className,
      locations,
      setLocation,
    } = this.props;
    let { mapConfig } = this.state;
    const containerStyles = Object.assign({}, mapStyles.container, containerStyle);

    return (
      <div style={containerStyles} className={className}>
        <APIProvider apiKey={getConfig().services.google_maps.google_api_key}>
          <Map
            mapId="map_id"
            {...mapConfig}
            onCameraChanged={(event) => this.handleCameraChange(event)}
          >
            {(locations || []).map((store, index) => (
              <AdvancedMarker

                key={index}
                position={{ lat: parseFloat(store.latitude), lng: parseFloat(store.longitude) }}
                onClick={() => {
                  if (setLocation) {
                    setLocation(store);
                  }
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="42" viewBox="0 0 30 42" fill="none">
                  <g filter="url(#filter0_d_198_1958)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25 11.0085C25 5.50991 20.4967 1 14.9669 1C9.43709 1 5 5.51094 5 11.0085C5 20.5885 14.9669 33 14.9669 33C14.9669 33 25 20.5885 25 11.0085ZM19.7358 11.173C19.7358 13.7404 17.5493 15.8473 14.9669 15.8473C12.3844 15.8473 10.2651 13.7404 10.2651 11.173C10.2651 8.60559 12.3834 6.43286 14.9669 6.43286C17.5504 6.43286 19.7358 8.60559 19.7358 11.173Z" fill="var(--ion-color-primary)" />
                  </g>
                  <defs>
                    <filter id="filter0_d_198_1958" x="0.5" y="0.5" width="29" height="41.2969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_198_1958" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_198_1958" result="shape" />
                    </filter>
                  </defs>
                </svg>
              </AdvancedMarker>
            ))}
          </Map>
        </APIProvider>
      </div>
    );
  }
}

export default MapWrapper;
